import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// @mui
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  CircularProgress,
  TextField,
} from '@mui/material';

import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import CustomSnackBar from '../components/snackbar';
import MenuPopover from '../components/popover/menuPopover';
// sections
import { UserListHead } from '../sections/@dashboard/user';
import RestaurantDialog from '../sections/dialogs/restaurantDialog';

// api
import { getAccounts, deleteAccount, updateAccountStatus  } from '../api/account';
import AccountFilter from '../sections/@dashboard/request/AccountFilter';

// ----------------------------------------------------------------------

const SUPER_ADMIN_TABLE_HEAD = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'name', label: 'Restaurant Name', alignRight: false },
  { id: 'location', label: 'Location', alignRight: false },
  { id: 'website', label: 'Website', alignRight: false },
  { id: 'expirydate', label: 'Expiry Date', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------



export default function RestaurantList() {

  const location = useLocation();

  const [restaurantList, setRestaurantList] = useState(null);

  const [isLoading, setIsLoading] = useState(false)

  // snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)

  const [selectedItem, setSelectedItem] = useState(false)

  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const [action, setAction] = useState('');

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('name');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [filterData, setFilterData] = useState();

  const[filteredRestaurantList,setFilteredRestaurantList] = useState([]);

  const handleSearch = (event) => {
    const text = event.target.value
    setFilteredRestaurantList(restaurantList.filter((item) => item.restaurantName?.toLowerCase().includes(text.toLowerCase()) || item.lastName?.toLowerCase().includes(text.toLowerCase())))
  };

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data } = await getAccounts();
      console.log(data);
      setRestaurantList(data.data.accounts)
      setFilteredRestaurantList(data.data.accounts)
      setFilterData(location.state?.filter ? location.state?.filter : 'all')
      // console.log(data.hospitalAccounts);
      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }

  }

  // get accounts list
  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (id) => {
    // console.log(id);
    try {
      const { data } = await deleteAccount(id);
      setMenuOpen(false)
      setIsLoading(false)
      fetchData()
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      setIsLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  }

  const handleSuspend = async (id, req) => {
    // console.log(id, req);
    try {
      const { data } = req === 'Suspend' ? await updateAccountStatus(id, {status: 'suspend'}) : await updateAccountStatus(id, {status: 'active'}) ;

      setMenuOpen(false)
      setIsLoading(false)
      fetchData()
      setSnackbarMessage({ msg: data.message, success: true });
      setSnackbarOpen(true);
    }
    catch (e) {
      setIsLoading(false)
      setSnackbarMessage({ msg: e.message, success: false });
      setSnackbarOpen(true);
    }
  }


  const handleOpenMenu = (event, item) => {
    // console.log(item);
    setSelectedItem(item)
    setMenuOpen(event.currentTarget);
  };

  // Dialog
  const handleDialogOpen = (item, str) => {
    // console.log(str,item);
    setAction(str)
    setDialogOpen(true);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

return(

    <>
      <Helmet>
        <title> Restaurant | Teller One </title>
      </Helmet>

      <Box sx={{ height: '100%' }}>
        {!isLoading ? (
          <Box>
            <Stack  mb={5}>
              <Typography variant="h4" gutterBottom>
                Restaurant List
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <TextField label='Search Restaurant' size='small' onChange={handleSearch} />
              <Button variant="contained" sx={{ borderRadius: 2 }} startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => handleDialogOpen(null, 'CREATE')}>
                Add Restaurant
              </Button>
              </Box>
            </Stack>
            <Card >
              {/* <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
              <Stack direction="row" alignItems="center" justifyContent="flex-end" mx={5}>
                <AccountFilter setFilterData={setFilterData} filterData={filterData} />
              </Stack>
              <Scrollbar>
                <TableContainer sx={{ minWidth: 1000 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={SUPER_ADMIN_TABLE_HEAD}
                      rowCount={restaurantList?.length}
                      numSelected={0}
                      onRequestSort={handleRequestSort}

                    />
                    <TableBody>
                      {restaurantList && filteredRestaurantList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const { _id, restaurantId, restaurantName, location, website, startDate, endDate, status, } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1} role="checkbox" >
                            {/* <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell> */}
                            <TableCell align="left">{restaurantId}</TableCell>

                            <TableCell component="th" scope="row" >
                              <Stack direction="row" alignItems="center" spacing={2}>
                                {/* <Avatar alt={name} src={avatarUrl} /> */}
                                <Typography variant="subtitle2" noWrap>
                                  {restaurantName}
                                </Typography>
                              </Stack>
                            </TableCell>
                            {/* <TableCell align="left">{license.length ? license.map((item,ind) => { return (`${item.licenseName}${license.length !== ind + 1 ? ', ' : ''} `) }) : <p>NIL</p>}</TableCell> */}
                            <TableCell align="left">{location}</TableCell>
                            <TableCell align="left">{website}</TableCell>
                            <TableCell align="left" sx={{ width: 160 }}>{endDate.split('T')[0]}</TableCell>
                            <TableCell align="left">
                              <Label color={status !== 'active' ? 'error' : 'success'}>{status}</Label>
                            </TableCell>

                            <TableCell align="right">

                              <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>



                            </TableCell>
                          </TableRow>
                        );
                      })}

                    </TableBody>


                  </Table>
                </TableContainer>

              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={restaurantList ? filteredRestaurantList.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><CircularProgress /></Box>
        )
        }
      </Box>
      {dialogOpen && <RestaurantDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} fetchData={fetchData} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} selectedItem={selectedItem} action={action} />}
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />
      <MenuPopover menuOpen={menuOpen} setMenuOpen={setMenuOpen} handleDialogOpen={handleDialogOpen} handleDelete={handleDelete} handleSuspend={handleSuspend} selectedItem={selectedItem} />
    </>
  );
}
